import React, { useState } from "react";
import { useShoppingCart } from "../../../context/CartContext.tsx/ShoppingCartContext";
import { FormatCurrency } from "../../../utils/FormatCurrency";

interface billingDataProps {
  amount_off?: number | any;
  bmsm_discount?: any;
  cashback?: number;
  free_variant_price?: number | any;
  gold_discount?: number;
  gold_variant_price?: any;
  item_total?: any;
  total?: number | any;
  total_discount?: number | any;
  wallet_amount?: number;
  cart_count?: number;
  cart_id?: number | any;
  cod?: number | any;
  shipping_charge?: number | any;
  is_gold_member?:boolean | any;
  is_lk_gold_member?:boolean | any;
  gold?:number | any;

}

export const BillingData = (props: billingDataProps) => {
  const { removeGold } = useShoppingCart();

  // console.log(typeof props.wallet_amount, 'wallet_amount');
  const [showBill, setShowBill] = useState(true);



  const data = {
    cart_id: props.cart_id,
  };

  let free_variant_price = parseInt(props.free_variant_price);
  // console.log(typeof props.shipping_charge, 'props.shipping_charge ')

  return (
    <div className="billingDataWrapper">
      <div
        className="billDetailsHeading detailHead"
        onClick={() => setShowBill(!showBill)}
      >
        <p>Billing Details</p>
        <p>
          <svg
            width="14"
            height="7"
            viewBox="0 0 14 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.28 0.966675L7.9333 5.31334C7.41997 5.82668 6.57997 5.82668 6.06664 5.31334L1.71997 0.966675"
              stroke="#666666"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </p>
      </div>

      {/* {showBill && */}

      <div className={`content ${showBill ? "visible" : "hidden"}`}>
        {props.item_total && props.item_total > 0 ? (
          <div className="billDetailsHeading itemTotal">
            <p className="billSubHeading">Item Total ({props.cart_count})</p>
            <p>Rs. {props.item_total} </p>
          </div>
        ) : (
          ""
        )}

        {props.shipping_charge && props.shipping_charge > 0 ? (
          <div className="billDetailsHeading deliveryFee">
            <p className="billSubHeading">Delivery Fee</p>
            <p className="deliveryAmount">Rs. {props.shipping_charge} </p>
          </div>
        ) : (
          <div className="billDetailsHeading deliveryFee">
            <p className="billSubHeading">Delivery Fee</p>
            <p className="deliveryFreeTag">FREE </p>
          </div>
           
        )}

        {props.bmsm_discount && props.bmsm_discount > 0 ? (
          <div className="billDetailsHeading bmsm">
            <p className="billSubHeading">BMSM Discount</p>
            <p className="discountPrice discountMinus">- Rs. {props.bmsm_discount} </p>
          </div>
        ) : (
          ""
        )}

        {free_variant_price && free_variant_price > 0 ? (
          <div className="billDetailsHeading propmoApplied">
            <p className="billSubHeading">Free Product Price</p>
            <p className="discountPrice discountMinus">- Rs. {free_variant_price} </p>
          </div>
        ) : (
          ""
        )}
        

        {props.wallet_amount && props.wallet_amount > 0 ? (
          <div className="billDetailsHeading wallet">
            <p className="billSubHeading">Aquacash</p>
            <p className="walletUsed discountMinus">
              - Rs. {props.wallet_amount}{" "}
            </p>
          </div>
        ) : (
          ""
        )}
    

        {props.gold_discount && props.gold_discount > 0 ? (
          <div className="billDetailsHeading goldMember">
            <div className="remobeButtonWrap">
                {props.is_lk_gold_member === true  && props.is_gold_member === true  &&
                    <p className="billSubHeading XclusiveHeading">Xclusive Discount</p>
                }
                {props.is_lk_gold_member === true  && props.is_gold_member === false  &&
                    <p className="billSubHeading XclusiveHeading">Lenskart Gold Discount</p>
                }
                {props.is_lk_gold_member === false  && props.is_gold_member === true  &&
                    <p className="billSubHeading XclusiveHeading">Xclusive Discount</p>
                }
                {props.is_lk_gold_member === false  && props.is_gold_member === false  &&
                    <p className="billSubHeading XclusiveHeading">Xclusive Discount</p>
                }
            </div>
            <p className="discountMinus"> - Rs. {props.gold_discount} </p>
          </div>
        ) : (
          ""
        )} 



        {props.amount_off && props.amount_off > 0 ? (
          <div className="billDetailsHeading propmoApplied">
            <p className="billSubHeading">Coupon Discount</p>
            <p className="discountPrice discountMinus">- Rs. {props.amount_off} </p>
          </div>
        ) : (
          ""
        )}

     

        {props.total_discount && props.total_discount > 0 ? (
          <div className="billDetailsHeading total_discount">
            <p className="billSubHeading">Total discount</p>
            <p className="discountMinus">
              - Rs. {props.total_discount + props.wallet_amount}{" "}
            </p>
          </div>
        ) : (
          ""
        )}


      {props.gold_variant_price && props.gold_variant_price > 0 ? (
          <div className="billDetailsHeading goldMember">
            <div className="remobeButtonWrap">
              <p className="billSubHeading memberDiscount">Xclusive Membership</p>
              <button onClick={() => removeGold(data)}>Remove</button>
            </div>
            <p className="memberDiscount"> Rs. {props.gold_variant_price} </p>
          </div>
        ) : (
           ""
        )}

        

        { props.total >= 0 ? (
          <div className="billDetailsHeading totalPay">
            <p>Total Payable Amount</p>
            <p>Rs. {props.total} </p>
          </div>
        ) : (
          ""
        )}
        
      </div>
    </div>
  );
};
